/**
 * Cache Storage bucket for pre-fetched player media. Shared by the page-side
 * offline store (`offline-store.ts`) and the service worker (built from
 * `src/player/sw/sw.ts`).
 *
 * NEVER rename casually: every deployed desktop box keys its cached library
 * under this name — a new name abandons the old bucket and re-downloads the
 * whole library on the next sync.
 */
export const MEDIA_CACHE = "omnimedia-media-v1";
